import { Divider, Space, Empty, Collapse } from "antd";
import React from "react";

import styles from "./Integrations.module.scss";

import { dataList } from "../../../ConnectData/components/ComingSoonData/ComingSoonDataItem";
import { Description } from "../../../Description";

export const Integrations = () => {
  const items = dataList.map((item, index) => (
    {
      key: item.id,
      label: (<CollapseLabel icon={item.icon} title={item.title} />),
      children: (<Empty />)
    }
  ))
  return (
    <div className={styles.root}>
      <Space direction="vertical" size={16} className={styles.wrapper}>
        <Collapse items={items} size="large" />
      </Space>
    </div>
  );
};

interface CollapseLabelProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
}

const CollapseLabel: React.FC<CollapseLabelProps> = ({ icon, title, description }) => {
  return (
    <div className={styles.cardTitle}>
      <span className={styles.titleIcon}>{icon}</span>
      {title}
      {description && (
        <>
          <Divider className={styles.divider} type="vertical" />
          <Description theme={"t3"} className={styles.description}>
            {description}
          </Description>
        </>
      )}
    </div>
  );
};
